if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}
if (typeof window.Shopify.functions == 'undefined') {
  window.Shopify.functions = {};
}

localStorage.setItem('isDonationDisabledTriggered', false);